import React, { useMemo } from 'react';
import TableWithWrapper from '@Atoms/Table/TableWithWrapper';
import TextField from '@components/Atoms/TextField';
import { useExamScoreColumns, useExamScoreRows } from './ExamScoreTable.hooks';

const sx = {
  '.table-row-cell': {
    py: 1.5,
  },
};

const textFieldSx = {
  p: 0,
  m: 0,
  border: 'none',
  '& .MuiInputLabel-root': {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: 0,
  },
};

const ExamScoreTable = () => {
  const columns = useExamScoreColumns();
  const rows = useExamScoreRows();
  const [search, setSearch] = React.useState('');

  const filteredRows = useMemo(
    () =>
      rows
        .filter((row) => row.name.toLowerCase().includes(search.toLowerCase()))
        .map((row) => ({
          ...row,
          overAllScaledScore: row.overAllScaledScore == null ? null : Math.round(row.overAllScaledScore),
        })),
    [rows, search],
  );

  const [nameColumn, ...scoreColumns] = columns;

  const formattedColumns = [
    {
      ...nameColumn,
      headerTitle: (
        <TextField
          variant="standard"
          placeholder="Name"
          value={search}
          sx={textFieldSx}
          onChange={(event) => setSearch(event.target.value)}
          onClick={(event) => event.stopPropagation()}
        />
      ),
    },
    ...scoreColumns,
  ];

  if (!rows.length) {
    return null;
  }

  return <TableWithWrapper columns={formattedColumns} rows={filteredRows} hasPagination sx={sx} />;
};

export default ExamScoreTable;
